import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-txn-setup',
  templateUrl: './txn-setup.component.html',
  styleUrls: ['./txn-setup.component.css']
})
export class TxnSetupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
